<template>
  <div id="JournalMue">
    <div class="JournalMue">
      <!--      详情-->
      <div class="book_brief">
        <div class="left_brief">
          <div class="books_info">
            <!--            名称（蒙语）-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont"><span class="aqt_lang_mn">【 {{
                  $t('m.name_title') + $t('m.Chinese_Mongolian')|U2M
                }} 】</span>{{
                  titlelang_mn ? titlelang_mn : '' | U2M
                }}</p>
            </div>
            <!--            名称（汉语）-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_su"><span class="aqt_lang_mn contentfont">【 {{
                  $t('m.name_title') + $t('m.chinese')|U2M
                }} 】</span>{{
                  titlelang_zh ? titlelang_zh : '' | U2M
                }}</p>
            </div>
            <!--作者（蒙语）-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont"><span
                  style="margin-bottom: 8px">【 {{ $t('m.author') + $t('m.Chinese_Mongolian')|U2M }} 】 </span>

                <span v-if="infosData&&infosData.authors.length" v-for="(i,ind) in infosData.authors" :key="ind"
                      @click="getAuthors(i)">
           {{ (i.name_lang.mn && (ind != 0)) ? ' /' : '' }}
           <font style="color: var(--themeColor);cursor: pointer"> {{
               i.name_lang.mn
             }}</font>
        </span>

                <span v-if="infosData&&!infosData.authors.length&&authorlang_mn">{{ authorlang_mn | U2M }}</span>
              </p>
            </div>
            <!--作者（汉语）-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_su"><span class="aqt_lang_mn contentfont" style="margin-bottom: 8px">【 {{
                  $t('m.author') + $t('m.chinese')|U2M
                }} 】</span>
                <span v-if="infosData&&infosData.authors.length" v-for="(i,ind) in infosData.authors" :key="ind"
                      @click="getAuthors(i)">
           {{ (i.name_lang.zh && (ind != 0)) ? ' /' : '' }}
           <font style="color: var(--themeColor);cursor: pointer"> {{
               i.name_lang.zh
             }}</font>
        </span>

                <span v-if="infosData&&!infosData.authors.length&&authorlang_zh">{{
                    authorlang_zh
                  }}</span>
              </p>
            </div>

            <!--论文类型（蒙语）-->
            <div class="aqt_zhengzhuang" v-if="infosData&&infosData.lwlxinfo">
              <p class="aqt_lang_mn contentfont">
                <span>【 {{ $t('m.lunType') + $t('m.Chinese_Mongolian')|U2M }} 】</span>
                <span v-if="infosData.lwlxinfo.name_lang.mn">{{ infosData.lwlxinfo.name_lang.mn|U2M }}</span>
              </p>
            </div>
            <!--论文类型（汉语-->
            <div class="aqt_zhengzhuang" v-if="infosData&&infosData.lwlxinfo">
              <p class="aqt_su contentfont">
                <span class="aqt_lang_mn">【 {{ $t('m.lunType') + $t('m.Chinese_Mongolian')|U2M }} 】</span>
                <span v-if="infosData.lwlxinfo.name_lang.zh">{{ infosData.lwlxinfo.name_lang.zh|U2M }}</span>
              </p>
            </div>

            <!--关键词（蒙语）-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont"><span>【 {{ $t('m.gjc') + $t('m.Chinese_Mongolian')|U2M }} 】</span>{{
                  infosData.keywordlang ? infosData.keywordlang.mn ? infosData.keywordlang.mn : '' : '' | U2M
                }}</p>
            </div>
            <!--关键词（汉语）-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_su contentfont"><span class="aqt_lang_mn">【 {{
                  $t('m.gjc') + $t('m.chinese')|U2M
                }} 】</span>{{
                  infosData.keywordlang ? infosData.keywordlang.zh ? infosData.keywordlang.zh : '' : ''
                }}</p>
            </div>

            <!--摘要（蒙语）-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont"><span
                  style="min-height: 125px">【 {{ $t('m.zhaiyao') + $t('m.Chinese_Mongolian')|U2M }} 】</span>{{
                  infosData.summarylang ? infosData.summarylang.mn ? infosData.summarylang.mn : '' : '' | U2M
                }}</p>
            </div>
            <!--摘要（汉语）-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_su contentfont"><span class="aqt_lang_mn">【 {{
                  $t('m.zhaiyao') + $t('m.chinese')|U2M
                }} 】</span>{{
                  infosData.summarylang ? infosData.summarylang.zh ? infosData.summarylang.zh : '' : '' | U2M
                }}</p>
            </div>

            <!--来源（蒙语）-->
            <!--            <div class="aqt_zhengzhuang">-->
            <!--              <p class="aqt_lang_mn contentfont"><span>【 {{ $t('m.source') + $t('m.Chinese_Mongolian')|U2M }} 】</span>{{-->
            <!--                  infosData.sourcelang ? infosData.sourcelang.mn ? infosData.sourcelang.mn : '' : '' | U2M-->
            <!--                }}</p>-->
            <!--            </div>-->
            <!--来源（汉语）-->
            <!--            <div class="aqt_zhengzhuang">-->
            <!--              <p class="aqt_su contentfont"><span class="aqt_lang_mn">【 {{-->
            <!--                  $t('m.source') + $t('m.chinese')|U2M-->
            <!--                }} 】</span>{{-->
            <!--                  infosData.sourcelang ? infosData.sourcelang.zh ? infosData.sourcelang.zh : '' : ''-->
            <!--                }}</p>-->
            <!--            </div>-->

            <!--下载量-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont">
                <span>【 {{ $t('m.downNum')|U2M }} 】</span>
                {{ infosData ? infosData.dowload : '' }}
              </p>
            </div>
            <!--引用量-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont">
                <span>【 {{ $t('m.yinyNum')|U2M }} 】</span>
                {{ infosData ? infosData.quotations : '' }}
              </p>
            </div>
            <!--阅读量-->
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont">
                <span>【 {{ $t('m.readingNum')|U2M }} 】</span>
                {{ infosData ? infosData.pageviews : '' }}
              </p>
            </div>


          </div>
        </div>
      </div>
      <!--pdf-->
      <div class="book_pdflist" v-if="pdfList.length">
        <div class="_Title">
          <p>
            <i></i>
            <span class="aqt_lang_mn titlefont">{{ $t('m.Ebook') |U2M }}</span>
          </p>
        </div>
        <div class="_pdflist">
          <div class="list__pdflist" @click="showSelectPdf"
               v-for="(item,index) in pdfList" :key="index">
            <p class="aqt_lang_mn contentfont">
              {{ item.name ? item.name : '' | U2M }}
            </p>
            <p class="aqt_lang_mn contentfont">{{ change(item.size) }}</p>
          </div>
        </div>
      </div>

      <text-content v-if="infosData.iscontent>0" :pdfUrl="fileUrl" :type="infosData.type"
                    :isContent="infosData.iscontent" :ShowOpertion="'page'"
                    :directoryId="infoId" :infoId="periodicalId"></text-content>

      <!--    加载动画-->
      <AqtSpin v-if="isSpin"></AqtSpin>
      <file_preview style="display:none" :file_name="fileUrl" ref="file_preview"></file_preview>
      <!--      <goback style="position:fixed!important;top: 30px!important;right: 100px!important;"></goback>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoId: { //目录id
      type: [String, Number],
      default: ''
    },
    periodicalId: { //期刊id
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isSpin: false,
      infosData: '',
      fileUrl: '',
      pdfList: [],

      titlelang_mn: '',
      titlelang_zh: '',

      authorlang_mn: '',
      authorlang_zh: '',


    }
  },
  components: {
    //文字内容查看
    TextContent: re => require(['@/components/MN/TextContent'], re),
  },
  methods: {
    //  获取详情
    getbookDetails() {
      const _this = this;
      _this.isSpin = true
      let condition = {
        library_id: _this.library_id,
        directory_id: _this.infoId,
        member_id: _this.member_id,
        terminal: _this.$terminal,

        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/directory/find`, condition)
          .then((val) => {
            if (val.code == 200 && val.data) {
              _this.infosData = val.data
              if (val.data.titlelang && val.data.titlelang.mn) {
                let tm = val.data.titlelang.mn.split("᠁")
                if (tm && tm.length) {
                  if (tm.length == 1) {
                    _this.titlelang_mn = tm[0]
                    _this.authorlang_mn = val.data.authorlang && val.data.authorlang.mn ? val.data.authorlang.mn : ''
                  } else if (tm.length == 2) {
                    _this.titlelang_mn = tm[0]
                    _this.authorlang_mn = (val.data.authorlang && val.data.authorlang.mn ? val.data.authorlang.mn : tm[1])
                  }
                } else {
                  _this.titlelang_mn = val.data.titlelang && val.data.titlelang.mn?val.data.titlelang.mn:''
                  _this.authorlang_mn = val.data.authorlang && val.data.authorlang.mn ? val.data.authorlang.mn : ''
                }
              } else {
                _this.authorlang_mn = val.data.authorlang && val.data.authorlang.mn ? val.data.authorlang.mn : ''
              }

              if (val.data.titlelang && val.data.titlelang.zh) {
                let tz = val.data.titlelang.zh.split("……")
                if (tz && tz.length) {
                  if (tz.length == 1) {
                    _this.titlelang_zh = tz[0]
                    _this.authorlang_zh = val.data.authorlang && val.data.authorlang.zh ? val.data.authorlang.zh : ''
                  } else if (tz.length == 2) {
                    _this.titlelang_zh = tz[0]
                    _this.authorlang_zh = (val.data.authorlang && val.data.authorlang.zh ? val.data.authorlang.zh : tz[1])
                  }
                } else {
                  _this.titlelang_zh = val.data.titlelang && val.data.titlelang.zh?val.data.titlelang.zh:''
                  _this.authorlang_zh = val.data.authorlang && val.data.authorlang.zh ? val.data.authorlang.zh : ''
                }

              } else {
                _this.authorlang_zh = val.data.authorlang && val.data.authorlang.zh ? val.data.authorlang.zh : ''
              }


              if (val.data.original) {
                // _this.showSelectPdf()
                let pdf_list = {
                  type: '',
                  url: '',
                  name: val.data.name,
                  size: val.data.size,
                  videopic: '',
                  voratime: '',
                  lx: '',
                  id: '',
                }
                _this.pdfList[0] = pdf_list
              }
              _this.isSpin = false
            } else {
              _this.isSpin = false
            }
          }).catch(e => {
        _this.isSpin = false
      })
    },
    showSelectPdf() {
      let that = this
      that.isSpin = true
      let condition = {
        model: that.infosData.type == 4 ? 'Paper' : 'QiKanMuLu',
        filetype: 'File',
        level: 'AQT_2023_1',
        id: that.infoId,//目录id
        type1: 12,
        name: that.infosData.type == 4 ? '论文详情pdf' : '期刊目录pdf',
      }
      that.$getResources(condition).then((val) => {
        if (val.code == 200) {
          that.fileUrl = that.$webcrypto.get(val.data)
        } else {
          that.$Message.warning({
            content: val.message
          })
        }
        that.isSpin = false
      }).catch((err) => {
        that.isSpin = false
      });
    },
    saveUserBehavior(type, mark, id) {
      let that = this

      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      }
      that.$store.dispatch('saveUserBehavior', info).then(() => {
      })

    },
    //  进入作者详情
    getAuthors(i) {
      let _this = this;
      return
      _this.$router.push({
        path: "AuthorDetails",
        query: {
          lib_type:sessionStorage.getItem('gcm'),
          id: _this.$crypto.set(i.author_id),
        },
      });
    },
    change(limit) {
      if (!limit) {
        return
      }
      var size = "";
      if (limit < 0.1 * 1024) {                            //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B"
      } else if (limit < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB"
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
      } else {                                            //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
      }

      var sizeStr = size + "";                        //转成字符串
      var index = sizeStr.indexOf(".");                    //获取小数点处的索引
      var dou = sizeStr.substr(index + 1, 2)            //获取小数点后两位的值
      if (dou == "00") {                                //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size;
    },
  },
  created() {
    this.getbookDetails()
    this.saveUserBehavior(12, '期刊目录详情', this.infoId)
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get((localStorage.getItem("theme_color")))).library_id : "";
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  }
}
</script>
<style lang="less" scoped>
#JournalMue {
  width: 100%;
  height: 100%;
  display: flex;

  .JournalMue {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    overflow-x: auto;
    position: relative;

    .book_brief {
      height: 100%;
      background: #ffffff;
      margin-right: 10px;
      padding: 27px 10px;
      display: flex;
      position: relative;

      .pdfButton {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 30px;
          height: auto;
          cursor: pointer;
        }
      }

      .left_brief {
        min-width: 180px;
        height: 100%;
        padding-top: 20px;


        .books_info {
          display: flex;
          min-width: 180px;
          padding-top: 10px;
          height: 100%;

          .title {
            height: 100%;
            color: #888888;
            font-size: 1.8rem;
            margin: 0 0.3rem;

            p {
              word-wrap: break-word;
              word-break: normal;
              height: 100%;
            }
          }

          .aqt_zhengzhuang {
            height: 100%;
            color: #888888;
            font-size: 1.2rem;
            margin: 0 .3rem;
            padding: 5px 0;

            p {
              font-size: 1.6rem;
              word-wrap: break-word;
              word-break: normal;
              color: #888888;
              display: flex;
              line-height: 24px;

              span {
                display: block;
                margin-bottom: 5px;
              }

              span:nth-child(1) {
                color: var(--themeColor);
                min-height: 100px;
              }
            }
          }
        }
      }

    }

    .book_pdf {
      width: 50%;
      height: 100%;
      background: #ffffff;
      //padding-bottom: 5px;
    }

    .book_pdflist {
      height: 100%;
      margin-right: 10px;
      display: flex;

      ._pdflist {
        height: 100%;
        padding: 35px 17px;
        display: flex;
        background: #ffffff;

        .list__pdflist {
          height: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          //background: #F2F7FF;
          background: #eeeeee;
          padding: 10px;
          cursor: pointer;

          p:nth-child(1) {
            height: 85%;
          }

          p:nth-child(2) {
            height: 15%;
            text-align: center;
          }
        }

        .list__pdflist:hover {
          color: var(--themeColor);
        }
      }
    }


    ._Title {
      width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 35px;
      display: flex;
      justify-content: center;

      p:nth-child(1) {
        width: 24px;
        font-size: 20px;
        line-height: 24px;

        i {
          display: block;
          width: 27px;
          height: 13px;
          background: var(--themeColor);
          margin-bottom: 14px;
        }
      }
    }
  }

  .JournalMue::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 12px;
  }

  .JournalMue::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .JournalMue::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

}
</style>
